import { AxiosResponse } from 'axios'
import ICaminhao from 'modules/caminhao/domain/entities/Caminhao'
import ICreateCaminhaoRequest from 'modules/caminhao/domain/entities/CreateCaminhaoRequest'
import IGetCaminhaoRequest from 'modules/caminhao/domain/entities/FindCaminhaoRequest'
import IFindCaminhaoResponse from 'modules/caminhao/domain/entities/FindCaminhaoResponse'
import { ICaminhaoRepository } from 'modules/caminhao/domain/repositories/ICaminhaoRepository'
import { ServiceConfig } from 'shared/services/ServiceConfig'

const http = new ServiceConfig()

export default class CaminhaoRepository implements ICaminhaoRepository {
  public async findAll(
    params: IGetCaminhaoRequest,
  ): Promise<IFindCaminhaoResponse> {
    const response: AxiosResponse<IFindCaminhaoResponse> = await http.get(
      '/caminhoes',
      {
        params: {
          page: params?.page,
          per_page: params?.per_page,
        },
      },
    )

    return response.data
  }

  public async findByDescricao(
    params: IGetCaminhaoRequest,
  ): Promise<IFindCaminhaoResponse> {
    const response: AxiosResponse<IFindCaminhaoResponse> = await http.get(
      '/caminhoes',
      {
        params: {
          page: params?.page,
          per_page: params?.per_page,
          descricao: params?.descricao,
        },
      },
    )

    return response.data
  }

  public async findByPlaca(
    params: IGetCaminhaoRequest,
  ): Promise<IFindCaminhaoResponse> {
    const paramsFilters = {}

    if (params?.tiposCarretaPermitidos) {
      params?.tiposCarretaPermitidos.forEach((permitido, index) => {
        paramsFilters[`tipos_carreta_tmov_id[${index}]`] = permitido
      })
    }

    if (params?.tiposCavaloPermitidos) {
      params?.tiposCavaloPermitidos.forEach((permitido, index) => {
        paramsFilters[`tipos_caminhao_tmov_id[${index}]`] = permitido
      })
    }

    const response: AxiosResponse<IFindCaminhaoResponse> = await http.get(
      '/caminhoes',
      {
        params: {
          page: params?.page,
          per_page: params?.per_page,
          placa: params?.placa,
          ativo: params?.ativo,
          frotista_id: params?.frotista_id,
          ...paramsFilters,
        },
      },
    )

    return response.data
  }

  public async delete(id: number): Promise<void> {
    await http.delete(`/caminhoes/${id}`)
  }

  public async activeOrInactive(caminhao: ICaminhao): Promise<void> {
    await http.patch(`/caminhoes/${caminhao.id}`, {
      ativo: caminhao.ativo,
    })
  }

  public async create(param: ICreateCaminhaoRequest): Promise<ICaminhao> {
    const response = await http.post('/caminhoes/', {
      frotista_id: param.frotista_id,
      descricao: param.descricao,
      tipo_caminhao_id: param.tipo_caminhao_id,
      veiculo_cavalo_id: param.veiculo_cavalo_id,
      veiculo_carreta1_id: param.veiculo_carreta1_id,
      veiculo_carreta2_id: param.veiculo_carreta2_id,
      veiculo_carreta3_id: param.veiculo_carreta3_id,
    })
    return response.data
  }
}
